export default __webpack_public_path__ + "static/media/1.851dfb1e.svg";